module.exports = __webpack_public_path__ + "img/soar-brand-min.85480af4.jpeg";